import store from '@/store'
import { permissionsRedirectUrls, pagesWithoutPermissions } from './permissions'

function checkAvailableRedirect(to) {
    const userPermissions = store.getters.permissions
    const urlId = to.params && to.params.id

    if (urlId) {
        permissionsRedirectUrls.forEach(it => {
            it.url = it.url.replace(':id', urlId)
        })
    }

    if (userPermissions) {
        const accessPages = permissionsRedirectUrls.filter(it =>
            userPermissions.includes(it.accessPermission)).map('url')

        const deniedPages = permissionsRedirectUrls.filter(it =>
            !userPermissions.includes(it.accessPermission)).map('url')

        if (!accessPages) {
            accessPages.push('/settings')
        }

        return {
            accessPages,
            deniedPages
        }
    }

    return {}
}

const rolesRedirectPages = {
    admin: '/payments',
    leader: '/dashboard',
    business: '/dashboard'
}

export async function isAuth(to, from, next) {
    await store.dispatch('getUser')

    if (store.getters.loggedIn && !store.getters.allDataFilled && to.path !== '/settings') {
        return next('/settings')
    }

    const { accessPages, deniedPages } = checkAvailableRedirect(to)

    let path = String(to.path)

    if (path.slice(-1).trim() === '/') {
        path = path.replace(/.$/, '')
    }

    if (!store.getters.loggedIn) {
        return next('/login')
    } else if (!to.meta.permission.includes(store.getters.type)) {
        return next(rolesRedirectPages[store.getters.type])
    } else if (store.getters.type === 'admin' &&
        deniedPages && deniedPages.includes(path)
    ) {
        return next(accessPages[0])
    } else if (store.getters.type === 'admin' &&
        !accessPages && !deniedPages &&
        !pagesWithoutPermissions.includes(path)
    ) {
        return next(pagesWithoutPermissions[0])
    }

    next()
}

export async function isNotAuth(to, from, next) {
    await store.dispatch('getUser')

    if (store.getters.loggedIn) {
        return next(rolesRedirectPages[store.getters.type])
    }

    next()
}

export async function checkClientReferralCode(to, from, next) {
    await store.dispatch('refRegister/checkReferralCode', { referralCode: to.params.id })
    next()
}

export async function checkBusinessReferralCode(to, from, next) {
    if (to.query.registered) {
        await store.commit('businessRegister/SET_REF_STATUS', 'registered')
    } else {
        await store.dispatch('businessRegister/checkReferralCode', to.params.id)
    }
    next()
}

export async function checkBusinessConfirmationCode(to, from, next) {
    await store.dispatch('businessRegister/confirmRegsiter', {
        referralCode: to.params.id,
        confirmationCode: to.params.confirmation
    })

    next()
}

export async function isAccountConfirmed(to, from, next) {
    await store.dispatch('confirmAccount', to.params.confirmationCode)

    next()
}
